import { render, staticRenderFns } from "./_user_activity.vue?vue&type=template&id=20bc1ccf&scoped=true&"
import script from "./_user_activity.vue?vue&type=script&lang=js&"
export * from "./_user_activity.vue?vue&type=script&lang=js&"
import style0 from "./_user_activity.vue?vue&type=style&index=0&id=20bc1ccf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bc1ccf",
  null
  
)

export default component.exports